<template>
  <BaseButton
    :text="`Buy Now${pricing}`"
    variant="secondary"
    class="w-100"
    @click="onBuyNowClick">
    <template #icon>
      <SvgShoppingCart/>
    </template>
  </BaseButton>
</template>

<script setup>
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import BaseButton from '@shared/components/ADORN/BaseButton.vue'
import { formatPrice } from '@/utils/stringParsing.js'
import useModals from '@/composables/modals.js'
import SvgShoppingCart from '@/components/global/svg/SvgShoppingCart.vue'
import { useClosetStore } from '@shared/stores/closet.js'
import { useClientStore } from '@shared/stores/client.js'

const props = defineProps({
  selectedItemType: {
    type: Object,
    default() { null }
  },
  styleColor: {
    type: Object,
    default() { null }
  }
})

const { canSelectItems } = storeToRefs(useClientStore())
const { itemTypePricing } = storeToRefs(useClosetStore())
const { openBuyItemModal } = useModals()

const canRentItem = computed(() => canSelectItems.value && props.styleColor?.rentable)
const pricing = computed(() => {
  if (!canRentItem.value && props.selectedItemType &&
    props.selectedItemType.id in itemTypePricing.value) {
    const price = itemTypePricing.value[props.selectedItemType.id].client
    return ` - ${formatPrice(price, true)}`
  }
  return ''
})

function onBuyNowClick() {
  openBuyItemModal({
    selectedItemType: props.selectedItemType,
    styleColor: props.styleColor
  })
}
</script>

<style lang="scss" scoped>
.base-button {
  --icon-size: 20px;
}
</style>
